import React, { Suspense } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { CssBaseline } from '@material-ui/core'
import Header from './components/Header'
/* import LandingActions from './components/LandingActions/LandingActions'
 */ // import ProgramFeatures from './components/ProgramFeatures/ProgramFeatures'
// import ProgramCountries from './components/ProgramCountries/ProgramCountries'
// import ProgramBenefits from './components/ProgramBenefits/ProgramBenefits'
/* import ProgramBenefitedSectors from './components/ProgramBenefitedSectors/ProgramBenefitedSectors'
 */ /* import ProgramEmail from './components/ProgramEmail/ProgramEmail'
 */ /* import Social from './components/Social/Social'
 */ /* import Footer from './components/Footer' */
import { FormContextProvider } from '../../context/formContext'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

const LandingActions = React.lazy(() =>
  import('./components/LandingActions/LandingActions'),
)

const ProgramFeatures = React.lazy(() =>
  import('./components/ProgramFeatures/ProgramFeatures'),
)

const ProgramCountries = React.lazy(() =>
  import('./components/ProgramCountries/ProgramCountries'),
)

const ProgramBenefits = React.lazy(() =>
  import('./components/ProgramBenefits/ProgramBenefits'),
)

const Social = React.lazy(() => import('./components/Social/Social'))

const ProgramEmail = React.lazy(() =>
  import('./components/ProgramEmail/ProgramEmail'),
)

const ProgramBenefitedSectors = React.lazy(() =>
  import('./components/ProgramBenefitedSectors/ProgramBenefitedSectors'),
)

const Footer = React.lazy(() => import('./components/Footer'))

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    /* backgroundImage: `url(${process.env.PUBLIC_URL + '/images/bg-cambio2-4.png'})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover', */
  },
}))
const LandingPage = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <FormContextProvider>
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '40vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <CssBaseline />
        </Suspense>
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '40vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <Header />
        </Suspense>

        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '40vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <LandingActions />
        </Suspense>
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '40vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  height: '40vh',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CircularProgress />
                </Box>
              </div>
            }
          >
            <ProgramFeatures />
          </Suspense>
        </Suspense>
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '40vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <ProgramCountries />
        </Suspense>
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '40vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <ProgramBenefits />
        </Suspense>

        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '40vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <ProgramBenefitedSectors />
        </Suspense>
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '40vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <ProgramEmail />
        </Suspense>
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '40vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <Social />
        </Suspense>
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '40vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <Footer />
        </Suspense>
      </FormContextProvider>
    </div>
  )
}

export default LandingPage
